module.exports = __webpack_public_path__ + "static/IMG-20200906-WA0002-43f729d9591d2dc12cb3a1faa31d156b.jpg";